import { render, staticRenderFns } from "./DashboardOptions.vue?vue&type=template&id=010d93b6&scoped=true&"
import script from "./DashboardOptions.vue?vue&type=script&lang=js&"
export * from "./DashboardOptions.vue?vue&type=script&lang=js&"
import style0 from "./DashboardOptions.vue?vue&type=style&index=0&id=010d93b6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "010d93b6",
  null
  
)

export default component.exports